declare global {
  interface Window {
    _oldScrollTo?: typeof window.scrollTo;
  }
}

export const ensureScrollRestoration = (delayTime = 25) => {
  if (!window._oldScrollTo) {
    console.log("ensureScrollRestoration set _oldScrollTo")
    const originalScrollTo = window.scrollTo.bind(window);
    window._oldScrollTo = originalScrollTo;

    window.scrollTo = function (xOrOptions?: number | ScrollToOptions, y?: number): void {
      const x = typeof xOrOptions === 'number' ? xOrOptions : (xOrOptions?.left || 0);
      const targetY = typeof xOrOptions === 'number' ? (y || 0) : (xOrOptions?.top || 0);

      console.log("ensureScrollRestoration scrollTo", targetY)
      window.requestAnimationFrame(() => {
        if (typeof xOrOptions === 'number') {
          originalScrollTo(xOrOptions, y || 0);
        } else {
          originalScrollTo(xOrOptions || { top: 0, left: 0 });
        }
      });

      let waitTime = delayTime;
      if (window.screen.width < 768) {
        waitTime = waitTime + delayTime;
      }

      if (typeof targetY !== 'number' || targetY === 0) {
        console.log('ensureScrollRestoration not number ', x, targetY);
        return;
      }

      console.log(`ensureScrollRestoration [${waitTime}]ms _oldScrollTo 0 = `, window.scrollY, targetY);

      const retryScroll = () => {
        if (window.scrollY !== targetY && (Math.abs(window.scrollY - targetY) / Math.abs(targetY)) > 0.05) {
          console.log("ensureScrollRestoration _oldScrollTo retry = ", window.scrollY, targetY);
          originalScrollTo(x, targetY);
        }
      };

      setTimeout(retryScroll, waitTime);
      setTimeout(retryScroll, waitTime * 2);
      setTimeout(retryScroll, waitTime * 3);
      setTimeout(retryScroll, waitTime * 4);
    } as typeof window.scrollTo;
  }
}
